const validationError = {
    invalidFileType: "file-invalid-type",
    multipleFile: "too-many-files",
    fileTooLarge: "file-too-large"
}

export default validationError